import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';

const QUEUE_API = 'https://j1u0gh1lxl.execute-api.ca-central-1.amazonaws.com';
const QUEUE_ID = '01KM41TEVB4A7GGG5P8XH3TJSR';
const JOIN_URL = 'https://d3dunnagrvlt6z.cloudfront.net/join/01KM41TEVB4A7GGG5P8XH3TJSR';
const POLL_INTERVAL = 30_000;

interface QueueStatus {
  isOpen: boolean;
  activeCount?: number;
}

export function WaitlistBanner() {
  const [status, setStatus] = useState<QueueStatus | null>(null);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;

    async function fetchStatus() {
      try {
        const res = await fetch(`${QUEUE_API}/queues/${QUEUE_ID}/public`);
        if (res.ok) {
          const data = await res.json();
          setStatus({ isOpen: data.isOpen, activeCount: data.activeCount });
        }
      } catch {
        // silently fail — banner just won't show
      }
    }

    fetchStatus();
    timer = setInterval(fetchStatus, POLL_INTERVAL);
    return () => clearInterval(timer);
  }, []);

  if (status === null) return null;

  const isLive = status.isOpen;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        className="relative z-30 mt-16"
      >
        {isLive ? (
          <a
            href={JOIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-gradient-to-r from-ndms-teal to-ndms-blue text-white text-center py-2.5 px-4 text-sm font-semibold hover:brightness-110 transition-all"
          >
            <span className="inline-flex items-center gap-2">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
              </span>
              Waitlist is LIVE — Join Now
              {status.activeCount != null && status.activeCount > 0 && (
                <span className="bg-white/20 rounded-full px-2 py-0.5 text-xs">
                  {status.activeCount} in line
                </span>
              )}
              <ArrowRight size={16} />
            </span>
          </a>
        ) : (
          <div className="bg-gradient-to-r from-ndms-teal to-ndms-blue text-white/50 text-center py-2 px-4 text-sm font-medium">
            <span className="inline-flex items-center gap-2">
              <Clock size={14} />
              Waitlist is currently closed
            </span>
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
